import { Box } from '@material-ui/core';
import React, { ReactNode } from 'react';

export interface ExpenseActionsProps {
  children: ReactNode;
}

export default function ExpenseActions({ children }: ExpenseActionsProps) {
  return <Box textAlign="right">{children}</Box>
}